import { render, staticRenderFns } from "./Coupon-Suggestion.vue?vue&type=template&id=2892b48a&"
import script from "./Coupon-Suggestion.vue?vue&type=script&lang=js&"
export * from "./Coupon-Suggestion.vue?vue&type=script&lang=js&"
import style0 from "./Coupon-Suggestion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports